import React, { useEffect } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import FullScreenLoader from "../../components/common/FullScreenLoader";

const AuthLayout = (props) => {
  const navigate = useNavigate();
  const { admin, authLoading } = useAdminAuth();

  useEffect(() => {
    if (!authLoading && !admin) {
      navigate("/admin/login", { replace: true });
    }
  }, [admin, authLoading, navigate]);

  // prevent flicker while auth state hydrates
  if (authLoading) {
    return <FullScreenLoader />;
  }

  // if unauthenticated, don't render layout
  if (!admin) return null;

  return (
    <React.Fragment>
      <DashboardLayout>{props.children}</DashboardLayout>
    </React.Fragment>
  );
};

export default AuthLayout;
